// import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import { withTranslation } from 'react-i18next';


export default compose(

  withState('showTariff', 'setShowTariff', false),
  withState('showAllTariffs', 'setShowAllTariffs', false),

  withHandlers({
    close: ({ setShowTariff, setShowAllTariffs }) => (e) => {
      if (e) {
        e.preventDefault();
      }
      setShowTariff(false);
      setShowAllTariffs(false);
    },
    openTariffInfo: ({ setShowTariff }) => (e) => {
      e.preventDefault();
      setShowTariff(true);
    },
    openAllTariffs: ({ setShowAllTariffs }) => (e) => {
      e.preventDefault();
      setShowAllTariffs(true);
    },
  }),

  withTranslation('subs')
);
